import React, { useCallback } from 'react';
import TableTop from '../../../core/table/TableTop';
import TableList from '../../../core/table/TableList';
import TableBody from '../../../core/table/TableBody';
import TablePaging from '../../../core/table/TablePaging';
import TableHead from '../../../core/table/TableHead';
import { useRouter } from '@uirouter/react';
import { useSplitInvoiceLineItemDispensesTableInit } from './useSplitInvoiceLineItemDispensesTableInit';
import { useSplitInvoiceLineItemDispensesTableState } from './useSplitInvoiceLineItemDispensesTableState';
import { useSplitInvoiceLineItemDispensesData } from './useSplitInvoiceLineItemDispensesData';
import { InvoiceLineItemDispensesDataItem } from './split_order_invoices_detail_types';
import { SPLIT_ORDER_INVOICES_ROUTE_DETAIL } from '../split_order_invoices_const';

const splitInvoiceLineItemDispensesTableId = 'splitInvoiceLineItemDispensesTableList';

type SplitInvoiceLineItemDispensesTableListProps = {
    invoiceId: string;
    lineItemId: string;
    rebatesOnly: boolean;
    userType: string;
};

const SplitInvoiceLineItemDispensesTableList = (props: SplitInvoiceLineItemDispensesTableListProps): JSX.Element => {
    const { init } = useSplitInvoiceLineItemDispensesTableInit();
    if (init) {
        return <></>;
    }
    return <TableWrapper {...props} />;
};

const TableWrapper = ({
    invoiceId,
    lineItemId,
    rebatesOnly,
    userType,
}: SplitInvoiceLineItemDispensesTableListProps): JSX.Element => {
    const router = useRouter();
    const { fltStats, paging, cols, sections, sort, filters, setFilter, setSort, setPaging } =
        useSplitInvoiceLineItemDispensesTableState();
    const { items } = useSplitInvoiceLineItemDispensesData();

    const navToFeature = useCallback(
        (backing: InvoiceLineItemDispensesDataItem): void => {
            const routeData = {
                id: invoiceId,
                rxid: backing.RXID,
                lineitemselected: {
                    offsetTop: 0,
                    item: { LineId: lineItemId },
                },
                rebatesOnly,
            };

            const breadcrumb = {
                icon: 'sprite-ndc-accum',
                route: SPLIT_ORDER_INVOICES_ROUTE_DETAIL,
                routeData,
                msg: 'Return to Invoice Split Detail',
            };

            const params = {
                Id: backing.AccumId,
                CE: backing.CEID,
                RX: backing.RXID,
                ShareGroup: null,
                CanEdit: userType === 'VERITYSA' || userType === 'VERITY' || userType === 'CE',
                breadcrumb,
            };

            router.stateService.go('ops.accum-detail', params, { reload: 'ops.accum-detail' });
        },
        [invoiceId, lineItemId, rebatesOnly, router, userType],
    );

    const handleDispenseRowClick = useCallback(
        (rowItem: any): void => {
            navToFeature(rowItem);
        },
        [navToFeature],
    );

    return (
        <TableList noSpacing>
            <TableTop
                id={splitInvoiceLineItemDispensesTableId}
                fltStats={fltStats}
            />
            <table>
                <TableHead
                    cols={cols}
                    sections={sections}
                    sort={sort}
                    filters={filters}
                    setFilter={setFilter}
                    setSort={setSort}
                />
                <TableBody
                    cols={cols}
                    rows={items}
                    onClick={handleDispenseRowClick}
                />
            </table>
            <TablePaging
                paging={paging}
                setPaging={setPaging}
                fltStats={fltStats}
            />
        </TableList>
    );
};

export default SplitInvoiceLineItemDispensesTableList;
